import { render, staticRenderFns } from "./TransferDetailOfBigAmount.vue?vue&type=template&id=6fe9f5ae&scoped=true"
import script from "./TransferDetailOfBigAmount.vue?vue&type=script&lang=js"
export * from "./TransferDetailOfBigAmount.vue?vue&type=script&lang=js"
import style0 from "./TransferDetailOfBigAmount.vue?vue&type=style&index=0&id=6fe9f5ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe9f5ae",
  null
  
)

export default component.exports